var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAcabamento = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 113,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.36 2.153v103.444c16.73 0 33.637-3.475 46.821-13.76 12.1-9.431 20.758-23.496 34.644-29.95 7.854-3.627 16.69-4.467 25.335-4.696 14.613-.407 29.327.776 43.353 5.091V.995",
    fill: "url(#paint0_linear)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.848 73.509l-9.422-6.975a7.08 7.08 0 01-1.53-9.775l22.696-31.542a4.804 4.804 0 00-.918-6.516l-7.931-6.365a4.787 4.787 0 00-6.63.624l-3.57 4.15-4.91-4.2 3.558-4.15A11.26 11.26 0 0181.76 7.322l7.943 6.287a11.224 11.224 0 012.142 15.363L69.149 60.526a.598.598 0 00.127.815l9.423 7-3.85 5.168z",
    fill: "#EE8322"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M74.848 73.509l-9.422-6.975a7.08 7.08 0 01-1.53-9.775l22.696-31.542a4.804 4.804 0 00-.918-6.516l-7.931-6.365a4.787 4.787 0 00-6.63.624l-3.57 4.15-4.91-4.2 3.558-4.15A11.26 11.26 0 0181.76 7.322l7.943 6.287a11.224 11.224 0 012.142 15.363L69.149 60.526a.598.598 0 00.127.815l9.423 7-3.85 5.168z",
    fill: "url(#paint1_linear)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.047 97.38L82.503 64.837a5.693 5.693 0 00-7.96 1.142l-2.01 2.68a5.67 5.67 0 001.144 7.946l43.544 32.542a5.692 5.692 0 007.96-1.142l2.01-2.68a5.67 5.67 0 00-1.144-7.947z",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.77,
    d: "M126.047 97.38L82.503 64.837a5.693 5.693 0 00-7.96 1.142l-2.01 2.68a5.67 5.67 0 001.144 7.946l43.544 32.542a5.692 5.692 0 007.96-1.142l2.01-2.68a5.67 5.67 0 00-1.144-7.947z",
    fill: "url(#paint2_linear)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.51 101.435a3.3 3.3 0 01.191.815 2.788 2.788 0 01-1.559 2.721c-.334.164-.697.26-1.067.283a2.762 2.762 0 01-1.926-.611 2.79 2.79 0 003.086 1.684 2.785 2.785 0 001.275-4.892z",
    fill: "#079D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.701 102.25a3.266 3.266 0 00-.191-.815 2.756 2.756 0 00-1.925-.611 2.807 2.807 0 00-2.627 2.966c.017.28.082.556.192.815a2.755 2.755 0 001.925.61 2.802 2.802 0 002.626-2.965z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.825 14.627l-3.06-6.415-2.321 2.648",
    fill: "#EE8322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.563 13.334L7.68 69.182C3.983 74.112 4.99 81.1 9.928 84.79l5.246 3.921c4.939 3.69 11.939 2.686 15.636-2.243l41.883-55.849c3.697-4.93 2.69-11.917-2.248-15.608l-5.246-3.92C60.261 7.4 53.261 8.404 49.563 13.334z",
    fill: "#D7D8D6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M49.563 13.334L7.68 69.182C3.983 74.112 4.99 81.1 9.928 84.79l5.246 3.921c4.939 3.69 11.939 2.686 15.636-2.243l41.883-55.849c3.697-4.93 2.69-11.917-2.248-15.608l-5.246-3.92C60.261 7.4 53.261 8.404 49.563 13.334z",
    fill: "url(#paint3_linear)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 100.095,
    y1: 92.474,
    x2: 36.648,
    y2: -17.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 62.582,
    y1: 39.181,
    x2: 93.962,
    y2: 39.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE8322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F19A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F4B276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F7C79B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FAD8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FCE6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDF1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEF9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 71.411,
    y1: 86.976,
    x2: 128.33,
    y2: 86.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 218.194,
    y1: 1117.36,
    x2: 5240.79,
    y2: 1117.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAcabamento);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/acabamento.7ab18c89b13298a844ca69168b573113.svg";